import enumeration from './enums.json'

export const en = {
  enum: enumeration,
}
